(() => {
	angular.module('main').directive('snAttachFiles', snAttachFiles);

	snAttachFiles.$inject = ['$filter', 'fileUploadService', 'imageConverter'];

	function snAttachFiles($filter, fileUploadService, imageConverter) {
		return {
			restrict: 'AE',
			replace: true,
			transclude: true,
			scope: {
				filesObj: '=snAttachments'
			},
			template: `<div class="attachments__box">
                        <input class="attachments__input hide" type="file" file-input="files" multiple />
                        <h4 ng-if="attachmentsView.length > 0">Files attached</h4>
                        <ul class="attachments__list">
                            <li ng-repeat="file in attachmentsView track by $index" class="file-type {{file.convertedType}}">
                                <div class="file-content-wrapper"> <b class="file-name">{{file.name}}</b>
                                    <p>{{file.convertedSize}}Mb</p>
                                </div>
                                <div class="remove-btn-wrapper"> <i class="fa fa-close file-remove" ng-click="removeAttachment($index)"></i> </div>
                            </li>
                        </ul>
                    </div>`,
			link(scope) {
				scope.attachmentsView = [];

				scope.$on('attachments', (e, data) => {
					console.log(scope.filesObj, 'attachments old');
					if (scope.attachmentsView === null) {
						scope.attachmentsView = [];
					}
					angular.forEach(data.attachments, value => {
						scope.attachmentsView.push(value);
						scope.attachmentsView = fileUploadService.removeDuplicates(
							scope.attachmentsView,
							'id'
						);
						buildFileObj();
					});
				});

				scope.$watchCollection('filesObj', newValue => {
					console.log(scope.filesObj, 'attachments old new');

					if (newValue) {
						scope.attachmentsView = newValue.attachments;
					}
				});

				scope.$watch('attachmentsView | json', (newValue, oldValue) => {
					if (newValue && newValue !== '[]' && newValue !== oldValue) {
						buildFileObj();
					}
				});

				scope.$watch('files', newValue => {
					if (newValue && newValue.length > 0) {
						const max = newValue.length;
						if (scope.attachmentsView === null) {
							scope.attachmentsView = [];
						}
						for (let i = 0; i < max; i++) {
							scope.attachmentsView.push(newValue[i]);

							angular.forEach(scope.attachmentsView, value => {
								value.convertedType = imageConverter.getFileClass(value.name);

								if (value.bytesSize) {
									value.convertedSize = (
										parseInt(value.bytesSize) /
										(1024 * 1024)
									).toFixed(2); // convert from bytes to MB
								} else {
									value.convertedSize = (
										parseInt(value.size) /
										(1024 * 1024)
									).toFixed(2); // convert from bytes to MB
								}
							});
						}
						scope.$evalAsync();
						scope.files = null;
					}
				});

				scope.removeAttachment = function(index) {
					scope.attachmentsView.splice(index, 1);
					scope.$evalAsync();
				};

				function buildFileObj() {
					if (
						scope.attachmentsView !== undefined ||
						scope.attachmentsView !== null
					) {
						const max = scope.attachmentsView.length;
						let size = 0;

						for (let i = 0; i < max; i++) {
							const fileSize =
								scope.attachmentsView[i].size ||
								scope.attachmentsView[i].bytesSize;
							size += fileSize;
						}
						size /= 1024 * 1000;
						size = $filter('number')(size, 2);

						scope.filesObj.filesSize = size;
						angular.forEach(scope.attachmentsView, value => {
							value.convertedType = imageConverter.getFileClass(value.name);

							if (value.bytesSize) {
								value.convertedSize = (
									parseInt(value.bytesSize) /
									(1024 * 1024)
								).toFixed(2); // convert from bytes to MB
							} else {
								value.convertedSize = (
									parseInt(value.size) /
									(1024 * 1024)
								).toFixed(2); // convert from bytes to MB
							}
						});

						scope.filesObj.attachments = scope.attachmentsView;
					}
				}
			}
		};
	}
})();



// WEBPACK FOOTER //
// ./web/js/components/Elements/snAttachFiles.js